import { render } from "./BeneficiaryPhotoModal.vue?vue&type=template&id=3f26771f&scoped=true"
import script from "./BeneficiaryPhotoModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryPhotoModal.vue?vue&type=script&lang=js"

import "./BeneficiaryPhotoModal.vue?vue&type=style&index=0&id=3f26771f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f26771f"]])

export default __exports__